// src/config/index.js
const { customerFormConfig } = require('./bidit');

export { customerFormConfig };
